/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import React, { useContext, useState } from 'react';
import { SessionContext } from '../../../context/SessionContext';
import { isDesktopOnly, isWebAllowed } from '../../../services/MeetingService';
import { GoToDownloadInstructions } from '../DownloadInstructions/GoToDownloadInstructions';
import { GoToFirstJoinDesktopOnly } from './GoToFirstJoinDesktopOnly';
import { GoToFirstJoinNativeAndWeb } from './GoToFirstJoinNativeAndWeb';
import { GoToFirstJoinUnsupportedBrowser } from './GoToFirstJoinUnsupportedBrowser';

export interface FirstJoinPageProps {
  onStartButtonClick: () => void;
}

export const GoToFirstJoin: React.FC = () => {
  const { meetingInfo, isDesktopEnforced } = useContext(SessionContext);
  const [showDownloadInstructions, setShowDownloadInstructions] =
    useState(false);

  if (showDownloadInstructions) {
    return <GoToDownloadInstructions />;
  }

  if (isDesktopOnly(meetingInfo, isDesktopEnforced)) {
    return (
      <GoToFirstJoinDesktopOnly
        onStartButtonClick={() => setShowDownloadInstructions(true)}
      />
    );
  } else if (isWebAllowed(isDesktopEnforced)) {
    return (
      <GoToFirstJoinNativeAndWeb
        onStartButtonClick={() => setShowDownloadInstructions(true)}
      />
    );
  } else {
    return (
      <GoToFirstJoinUnsupportedBrowser
        onStartButtonClick={() => setShowDownloadInstructions(true)}
      />
    );
  }
};
